import {
  event as gaEvent,
  set as gaSet,
  screenview as gaScreenview
} from 'vue-gtag'

export const ga4ScreenView = (screenName: string, appName: string = 'KuraemonCloudWeb') => {
  try {
    gaScreenview({
      app_name: appName,
      screen_name: screenName
    });
  } catch (e) {
    console.error(e);
  }
}

export const ga4Event = (eventName: string, eventParams: any)  => {
  try {
    gaEvent(
      eventName,
      eventParams
    );
  } catch (e){
    console.error(e);
  }
}

export function updateGa4UserId(accountId: string) {
  try {
    gaSet({ user_id : accountId });
    gaSet({
      user_properties: {
        account_id: accountId
      }
    });
  } catch (e){
    console.error(e);
  }
}
